import { ObjectUpdate } from '../../../concepts/objects';
import { CreatePhysicalToolBehavior2 } from '../../canvas/tooling/CreatePhysicalToolBehavior2';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { ColorList } from './../../../ui';
import { Token } from './Token';

class CreateTokenToolBehavior extends CreatePhysicalToolBehavior2(Token) {

    protected createSubject(u: ObjectUpdate) {
        const token = super.createSubject(u);
        token.background = this.settings.color ?? ColorList[7];
        token.value = this.settings.value ?? '';
        return token;
    }
}

export const tokenTool = defineToolWithCommonBehaviors({
    id: 'tokenTool',
    label: 'Tokens',
    category: 'collaboration',
    icon: 'deqo://icons/d2/token',
    weight: 1045,
    shortcut: 'E',
    behaviors: [CreateTokenToolBehavior]
});

